import { ApplicationRef, ChangeDetectorRef, Component, ElementRef, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PuzzleButtonBarComponent } from '../puzzle-button-bar/puzzle-button-bar.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { PuzzleFrameworkService } from '../../../../tools/src/lib/puzzle-framework-module/puzzle-framework.service';
import { PuzzleAnalyticsService } from '../../../../tools/src/lib/shared-module/puzzle-analytics/puzzle-analytics.service';
import { PuzzleHelpDialogService } from '../../../../tools/src/lib/shared-module/puzzle-help-dialog/puzzle-help-dialog.service';
import { PuzzleZoomService } from '../../../../tools/src/lib/shared-module/puzzle-zoom/puzzle-zoom.service';
import {
  AlertController,
  MenuController,
  ModalController,
  IonBadge,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonTitle,
  IonToggle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { menuSharp, closeOutline } from 'ionicons/icons';
import { usedButtonBarIcons } from 'projects/web/src/app/puzzle-button-bar/puzzle-button-bar.component';
import { HelperFunctionsService } from '../../../../tools/src/lib/shared-module/helpers/helper-functions.service';
import { LeaderboardService } from 'projects/tools/src/lib/shared-module/leaderboard/leaderboard.service';
import { FeedbackService } from 'projects/tools/src/lib/shared-module/feedback/feedback.service';
import { TooltipModule } from 'ng2-tooltip-directive-major-angular-updates';

@Component({
  selector: 'app-puzzle-sidenav',
  templateUrl: './puzzle-sidenav.component.html',
  styleUrls: ['./puzzle-sidenav.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    IonBadge,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonList,
    IonTitle,
    IonToolbar,
    IonToggle,
    TooltipModule,
  ],
})
export class PuzzleSidenavComponent extends PuzzleButtonBarComponent implements OnInit {
  public buttonOrdersSelector = 'sidenavButtonOrder';
  removeSideMargins: boolean;

  showXInsteadOfCloseButton = false;

  constructor(
    translate: TranslateService,
    cd: ChangeDetectorRef,
    store: Store,
    framework: PuzzleFrameworkService,
    analytics: PuzzleAnalyticsService,
    injector: Injector,
    applicationRef: ApplicationRef,
    private sideNavHelpDialogService: PuzzleHelpDialogService,
    el: ElementRef,
    zoom: PuzzleZoomService,
    ionicAlert: AlertController,
    private sideNavIonicMenu: MenuController,
    ionicModal: ModalController,
    helperFunctions: HelperFunctionsService,
    public leaderboard: LeaderboardService,
    public feedback: FeedbackService
  ) {
    super(
      translate,
      cd,
      store,
      framework,
      analytics,
      injector,
      applicationRef,
      sideNavHelpDialogService,
      el,
      zoom,
      ionicAlert,
      sideNavIonicMenu,
      ionicModal,
      helperFunctions,
      leaderboard,
      feedback
    );
    addIcons({
      menuSharp,
      closeOutline,
    });
    addIcons(usedButtonBarIcons);

    store
      .select((state) => state.puzzleFrameworkConfig.removeSideMargins)
      .subscribe((removeSideMargins) => (this.removeSideMargins = removeSideMargins));

    store
      .select((state) => state.puzzleFrameworkConfig.showXInsteadOfCloseButton)
      .subscribe((XInstead) => (this.showXInsteadOfCloseButton = XInstead));
  }

  injectButtons() {
    this.sideNavHelpDialogService.injectSideNavButtons(this.buttons);
  }

  closeMenu() {
    this.sideNavIonicMenu.close('sidemenu');
  }

  resolveState(slideToggleState: string): any {
    let current = this;
    slideToggleState.split('.').map((currentKey) => {
      if (current.hasOwnProperty(currentKey)) {
        current = current[currentKey];
      }
    });

    return current;
  }
}
